export class AddressFixer {
  constructor(params) {
    this.params = params
  }

  run = () => {
    this.handleUAE()

    this.params
  }

  // stripe returns United Arab Emirate emirate as state, flavorcloud requires it as a city too
  handleUAE = () => {
    if (this.params.country === 'AE') {
      this.params.city = this.params.state
    }
  }
}
